module.exports = __webpack_public_path__ + "img/38.96b00bdf.png";